import { SERVER_CHANGED } from './constants'

const initialState = { name: '', shortName: '' }

// sample state:
// const initialState = { name: 'Tranquility', shortName: 'tq' }

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // Server changed
        case SERVER_CHANGED: {
            return action.payload
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/LoadingBar/data/serverNames/reducers.js